import React from "react";
import Header from "./components/Header";
import Featured from "./components/Featured";
import Footer from "./components/Footer";
import Gallery from "./components/Gallery";
import Navbar2 from "./components/Navbar2";
import Opsnsorss from "./components/sponsors";
import ProfileCards from "./components/ProfileCards";
import Testimonials from "./components/Testimonials";
import FaqSection from "./components/FAQs/FaqSection";
import GlowingBackground from "./components/GlowingBackground/GlowingBackground";
import FinalCTA from "./components/FinalCTA";
import Rewards from "./components/Rewards";
import "./Home.css";

/**
 * Home — Main page
 * GSAP background-pulse removed.
 * ParallaxBackground added for cinematic visual styling.
 */
const Home = () => {
  return (
    <div className="app-content">
      <GlowingBackground />
      <Navbar2 />
      <Header />
      <Featured />
      <Testimonials />
      <Rewards />
      <Gallery />
      <FaqSection />
      <ProfileCards />
      <Opsnsorss />
      <FinalCTA />
      <Footer />
    </div>
  );
};

export default Home;
